import { createContext } from 'react';
import { AuthContextInterface } from './types';
import { initialAuthState } from "../_appData";

/**
 * @ignore
 */
const stub = (): never => {
  throw new Error('You forgot to wrap your component in <AuthProvider>.');
};

/**
 * @ignore
 */
const initialContext = {
  ...initialAuthState,
  getAuthorizeUrl: stub,
  getLogoutUrl: stub,
  getAccessToken: stub,
  userHasPrivilege: stub,
  loginWithRedirect: stub,
  loginWithPassword: stub,
  logout: stub,
  signup: stub,
  signupConfirm: stub,
  passwordReset: stub,
  passwordResetConfirm: stub,
  toggleNavigation: stub,
  canNavigate: stub,
};

/**
 * The Auth Context
 */
export const AuthContext = createContext<AuthContextInterface>(initialContext);

